/*global WDPRO*/

(function ($) {
    'use strict';

    var updateAttributes = function (attributes) {
        var me = this;
        $.each(attributes || {}, function (attr, newVal) {
            var curAttrVal;

            attr = attr.toLowerCase();
            if (attr !== 'id') {
                if (attr === 'url') {
                    attr = 'src';
                }

                curAttrVal = me.attr(attr);


                if (typeof curAttrVal !== 'undefined') {
                    if (attr === 'src') {
                        // hide until image loaded since load may come after DOM ready removal of styles
                        me.css('visibility', 'hidden');
                    }
                    me.attr(attr, newVal);
                }
            }
        });
        return me;
    };

    $.fn.updateAttributes = updateAttributes;
}(WDPRO.Personalization.$));
